export default "__VITE_ASSET__3cc0bcfc__"